import { render, staticRenderFns } from "./ItemMoudle.vue?vue&type=template&id=bab6323a&"
import script from "./ItemMoudle.vue?vue&type=script&lang=js&"
export * from "./ItemMoudle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports